import HistogramDefaultConfig from './HistogramDefaultConfig';

class HistogramColumnWithDrilldown extends HistogramDefaultConfig {
    constructor(options) {
        super(options);
    }
} export default HistogramColumnWithDrilldown;
